module.exports = __webpack_public_path__ + "assets/img/btn-back-b61e6307.png";